import { ChangeDetectionStrategy, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import * as FlatFacades from "@medsurf/flat-facades";
import * as FlatServices from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-audio',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.scss'],
    standalone: false
})
export class AudioComponent {
  @ViewChild('audioElement', {static: false}) audioElementRef: ElementRef;

  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public mediaControlService: FlatServices.MediaControlService) {
  }

  localToggle() {
    if (!this.audioElementRef.nativeElement && !this.audioElementRef.nativeElement.paused) {
      return;
    }
    if (this.audioElementRef.nativeElement.paused === true) {
      this.audioElementRef.nativeElement.play();
    } else {
      this.audioElementRef.nativeElement.pause();
    }
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event) {
    event.preventDefault();
  }

  @HostListener('window:keydown.space')
  handleSpaceKey() {
    this.localToggle();
  }
}
